module.exports = __webpack_public_path__ + "img/happy.179f616f.svg";